import React from "react";
import {
  Box,
  FormControl,
  TextField,
  Checkbox,
  styled
} from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import ModalTwoButtons from '../../../components/Modal/ModalTwoButtons';
import STMethodClassification from "../../../api/StationaryTesting/STMethodClassification";

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  marginBottom: "20px",
  gap: "20px",
  justifyContent: "normal!important"
}));

const StyledTextField = styled(TextField)(() => ({
  width: "35rem"
}));

const StyledFormControl = styled(FormControl)(() => ({
  display: 'flex',
  width: "50rem"
}));

const StyledDiv = styled('div')({
  display: 'flex',
  justifyContent: "space-between"
});

const STMethodForm = ({ infoData, setInfoData, invalidField, handleChangeSTMethodFilter, canEdit }) => {

  const [modalTwoButtonsOpen, setModalTwoButtonsOpen] = React.useState(false);

  function findMethod() {
    handleChangeSTMethodFilter(infoData.classificationName);
    closeModalTwoButtonsOpen();
  }

  function closeModalTwoButtonsOpen() {
    setModalTwoButtonsOpen(false);
  }

  function checkExistingMethod(method) {

    if (method) {
      STMethodClassification.get(method).then((methodExists) => {
        if ((methodExists !== undefined && methodExists !== null))
          setModalTwoButtonsOpen(true)
      });
    }
  }

  return (

    <div>
      <StyledDiv>
        <div>
          <StyledBox sx={{ flexDirection: 'column' }}>
            <StyledFormControl sx={{ m: 1 }} variant='outlined'>

              <StyledBox sx={{ justifyContent: "space-between" }}>
                <StyledTextField
                  onChange={e => {
                    setInfoData(() => ({
                      ...infoData,
                      classificationName: e.target.value
                    }))
                  }}
                  onBlur={e => {
                    checkExistingMethod(e.target.value)
                  }}
                  value={infoData.classificationName}
                  id="method-name"
                  label="Classification Name"
                  variant="outlined" size="small" margin="none"
                  error={invalidField.methodName.length === 0 ? false : true}
                  disabled={infoData.id || !canEdit ? true : false}
                  helperText={invalidField.methodName}
                  inputProps={{ maxLength: 50 }}
                />

                <FormControlLabel
                  label="Active"
                  onChange={e => setInfoData(() => ({
                    ...infoData,
                    isActive: e.target.checked
                  }))}
                  checked={infoData.isActive}
                  disabled={!canEdit}
                  control={<Checkbox />}
                />               
              </StyledBox>      

            </StyledFormControl>
          </StyledBox>

        </div>

      </StyledDiv>

      <ModalTwoButtons title={'Warning'} button1Text={'No'} button1Action={closeModalTwoButtonsOpen} button2Text={'Yes'} button2Action={findMethod} open={modalTwoButtonsOpen} setOpen={setModalTwoButtonsOpen}>
        <label>
          This Method Classification already exist, would you like to use it?
        </label>
      </ModalTwoButtons>

    </div>

  );
};

export default STMethodForm;
